import React from "react";
import { Link } from "react-router-dom";
import "./reasultCard.css"

const ResultCard = ({ item }) => {
  return (
    <div class="result-card">
      <img
        className="result-img"
        // src={`https://listendonate.herokuapp.com/${item.postImage}`}
        src={item.postImage}
        alt={item.postTitle}
      />
      <h2>
        <span>{item.postTitle[0]}</span>
        {item.postTitle.substring(1)}
      </h2>
      <button class="getBtn">
        <Link to={`/${item._id}`}>See More</Link>
      </button>
    </div>
  );
};

export default ResultCard;
